import type { ClusterUpdateFormData } from '@/contexts/useConfigCreateRequest'
import { z } from 'zod'

type RequestSchema = {
  [K in keyof ClusterUpdateFormData]: z.ZodType<ClusterUpdateFormData[K]>
}

export const clusterStep1Schema = z.object({
  _clusterName: z
    .string()
    .regex(
      /^[a-z][a-z0-9-]{3,13}[a-z0-9]$/,
      'Cluster name must start with a letter, end with a letter or number, and contain only lowercase letters, numbers, and hyphens.',
    )
    .min(5, 'Cluster name must be at least 5 characters long.')
    .max(15, 'Cluster name must be at most 15 characters long.')
    .min(1, 'Cluster name is required.'),
  _organizationId: z.string().min(1, 'Organization ID is required.'),
  template_id: z.string().min(1, 'Template ID is required.'),
  product_id: z.number().min(1, 'Product ID is required.'),
  _deploymentLabel: z.string().min(1, 'Deployment Label is required.'),
} as unknown as RequestSchema)
